import RequestToken from '../../../../tokens/RequestToken';
import {CommandRequester} from '../../../../CommandRequester';
import RequestAPI from '../../../RequestAPI';
import {AsyncCommandEvent, CommandTypes} from '@jibo/command-protocol';

/**
 * @class AttentionToken
 * @extends RequestToken
 * @hideconstructor
 */
export class AttentionToken extends RequestToken<JIBO.v1.AttentionRequest> {

    /** @private */
    constructor(owner:CommandRequester, protocol: JIBO.v1.AttentionRequest) {
        super(owner, protocol);
    }

    /**
     * @private
     */
    public handleAck(ack:JIBO.v1.Acknowledgement) {
        //handle ack
        if (ack.Response.ResponseCode >= 400) {
            this.isComplete = true;
            this._complete.reject(ack.Response);
            return;
        }
    }

    /**
     * @private
     */
    public handleEvent(event:JIBO.v1.EventMessage) {
        //handle event
        switch (event.EventBody.Event) {
            case AsyncCommandEvent.Stop:
                this.isComplete = true;
                this._complete.resolve();
                break;
            case AsyncCommandEvent.Error:
                this.isComplete = true;
                this._complete.reject(event.EventBody);
                break;
        }
    }
}

/**
 * Internal Attention class
 * @class CommandRequester.expression.Attention
 * @intdocs
 */
export class Attention extends RequestAPI<JIBO.v1.AttentionRequest, AttentionToken> {

    /**
     * Generate Attention Protocol
     * @method CommandRequester.expression.Attention#generateProtocol
     * @param {CommandRequester.expression.AttentionMode} mode - New attenion mode for the robot
     * @returns {JIBO.v1.AttentionRequest}
     * @intdocs
     */
    static generateProtocol(mode: CommandRequester.expression.AttentionMode): JIBO.v1.AttentionRequest {
        return {
            Type: CommandTypes.SetAttention,
            Mode: mode,
        } as JIBO.v1.AttentionRequest;
    }

    /**
     * Create AttentionToken from AttentionRequest protocol.
     * @method CommandRequester.expression.Attention#generateToken
     * @param {AttentionRequest} protocol - AttentionRequest protocol to generate an AttentionToken from.
     * @param {boolean} [andSend=false] - `true` if the generated AttentionToken should also be sent as a request.
     * @return {AttentionToken}
     * @intdocs
     */
    public generateToken(protocol: JIBO.v1.AttentionRequest, andSend=false): AttentionToken {
        const token = new AttentionToken(this.owner, protocol);
        if (andSend) {
            super.sendToken(token);
        }
        return token;
    }

    /**
     * Send AttentionToken request.
     * <p>NOTE: Implementation in base class {@link RequestAPI}</p>
     * @method CommandRequester.expression.Attention#sendToken
     * @param {AttentionToken} token - AttentionToken to send.
     * @intdocs
     */
}
